import {Action} from '@ngrx/store';
import {ArrayResponse, type} from '../../shared';
import {ContractFilter} from '../models/contract-filter';
import {ContractItem} from '../models/contract-item';

export const contractListActionTypes = {
  TOGGLE_SEARCH: type('[contracts] Toggle Search Form'),
  QUICK_SEARCH: type('[contracts] Quick Search'),
  SEARCH: type('[contracts] Search'),
  CHANGE_PAGE_SIZE: type('[contracts] Change Page Size'),
  PAGE_TO: type('[contracts] Page To'),
  ORDER_BY: type('[contracts] Order By'),
  LOAD: type('[contracts] Load'),
  LOAD_FULL: type('[contracts] Load Full'),
  SITE_LOAD: type('[contracts] Sties Load'),
  SITE_SUBSCRIPTION_LOAD: type('[contracts] Sties Subscription Load'),
  LOAD_SUCCESS: type('[contracts] Load Success'),
  LOAD_FAIL: type('[contracts] Load Fail'),
  SELECT_PAGE: type('[contracts] Select Page'),
  UNSELECT_PAGE: type('[contracts] Unselect Page'),
  TOGGLE_SELECTION: type('[contracts] Toggle Selection'),
  TOGGLE_SELECTION_TAGS: type('[contracts] Toggle Selection Tags'),
  CLEAR: type('[contracts] Clear Data')
};


export class ToggleSearchContractsAction implements Action {
  readonly type = contractListActionTypes.TOGGLE_SEARCH;
  constructor(public payload?: boolean) {}
}

export class QuickSearchContractsAction implements Action {
  readonly type = contractListActionTypes.QUICK_SEARCH;
  constructor(public payload?: string) {}
}

export class SearchContractsAction implements Action {
  readonly type = contractListActionTypes.SEARCH;
  constructor(public payload?: ContractFilter) {}
}

export class ChangeContractsPageSizeAction implements Action {
  readonly type = contractListActionTypes.CHANGE_PAGE_SIZE;
  constructor(public payload?: number) {}
}

export class PageContractsToAction implements Action {
  readonly type = contractListActionTypes.PAGE_TO;
  constructor(public payload?: number) {}
}

export class OrderContractsByAction implements Action {
  readonly type = contractListActionTypes.ORDER_BY;
  constructor(public payload?: string) {}
}

export class LoadContractsAction implements Action {
  readonly type = contractListActionTypes.LOAD;
  constructor() {}
}
export class LoadFullContractsAction implements Action {
  readonly type = contractListActionTypes.LOAD_FULL;
  constructor() {}
}
export class LoadSiteContractsAction implements Action {
  readonly type = contractListActionTypes.SITE_LOAD;
  constructor() {}
}
export class LoadSiteSubscriptionContractsAction implements Action {
  readonly type = contractListActionTypes.SITE_SUBSCRIPTION_LOAD;
  constructor() {}
}
export class LoadContractsSuccessAction implements Action {
  readonly type = contractListActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ArrayResponse<ContractItem>) {}
}

export class LoadContractsFailAction implements Action {
  readonly type = contractListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class ClearContractsAction implements Action {
  readonly type = contractListActionTypes.CLEAR;
  constructor() {}
}
